import type { HTMLAttributes, ReactElement } from 'react';

export interface ScreenProps extends HTMLAttributes<HTMLElement> {
  as?: 'div' | 'main';
  layout?: 'centered' | 'flow';
  height?: 'viewport' | 'dynamic';
}

export function Screen({
  as: Element = 'div',
  layout = 'centered',
  height = 'viewport',
  className,
  ...props
}: ScreenProps): ReactElement {
  const resolvedClassName = [
    'cards-kit-screen',
    `cards-kit-screen--${layout}`,
    `cards-kit-screen--${height}`,
    className,
  ].filter(Boolean).join(' ');
  return <Element {...props} className={resolvedClassName} />;
}
